import React from 'react'
import {connect} from 'react-redux'
import log from 'components/utils/Logger.js'
import * as Actions from 'redux/actions'
import moment from 'moment';
import 'moment/locale/ja';
import { LoadingOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Tabs, Collapse, Modal } from 'antd';
import ReactGridLayout from 'react-grid-layout'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import ModuleQuestionnaire from './modules/questionnaire/ModuleQuestionnaire'
import ModuleNotification from './modules/notification/ModuleNotification'
import ModuleLink from './modules/link/ModuleLink'
import ModuleCalendar from './modules/calendar/ModuleCalendar'
import NoContent from "../../components/NoContent";
import ModuleFileShare from "./modules/fileshare/ModuleFileShare";
import ModuleCurriculum from "./modules/curriculum/ModuleCurriculum";

moment.locale('ja')

const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const Panel = Collapse.Panel;

const mapStateToProps = (state, props) => {
    return {
        screen: state.screen,
        layoutLoad: state.layoutLoad,
        layoutSave: state.layoutSave,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        windowResize : (dataHeight,dataWidth) => {
            dispatch(Actions.Config.screen(dataHeight,dataWidth));
        },
        loadLayoutAdmin :(uuid) => {
            dispatch(Actions.AdminConnection.layout.load.request(uuid));
        },
        saveLayoutAdmin :(uuid,data) => {
            dispatch(Actions.AdminConnection.layout.save.request(uuid,data));
        }
    }
};

class ModuleLayoutModal extends React.Component {
    constructor(props) {
        super(props);
        log.debug(props);

        this.state = {
            menuDetail: typeof props.menuDetail !== "undefined"? props.menuDetail: {},
            visible: props.visible,
            title: props.title
        };

    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.menuDetail !== this.state.menuDetail && nextProps.visible){
            if(nextProps.menuDetail && nextProps.menuDetail.hasOwnProperty("uuid")){
                this.props.loadLayoutAdmin(nextProps.menuDetail.uuid);
            }
        }
        this.setState({
            menuDetail: nextProps.menuDetail ? nextProps.menuDetail: {},
            visible: nextProps.visible
        });

        if (nextProps.layoutLoad !== this.props.layoutLoad) {
            if (!nextProps.layoutLoad.meta.fetch) {
                if (!nextProps.layoutLoad.error) {
                    if (nextProps.layoutLoad.payload !== null) {
                        if(nextProps.layoutLoad.payload.result.hasOwnProperty("layout")) {
                            this.setState({
                                layoutLoading: nextProps.layoutLoad.meta.fetch,
                                layoutLoadArray: JSON.parse(nextProps.layoutLoad.payload.result.layout),
                            })
                        }else{
                            this.setState({
                                layoutLoading: true,
                                layoutLoadArray: [],
                            })
                        }
                    }
                } else {
                    this.setState({
                        layoutLoading: nextProps.layoutLoad.meta.fetch
                    })
                }
            } else {
                this.setState({
                    layoutLoading: nextProps.layoutLoad.meta.fetch
                })
            }
        }

        if (nextProps.layoutSave !== this.props.layoutSave) {
            if (!nextProps.layoutSave.meta.fetch) {
                if (!nextProps.layoutSave.error) {
                    if (nextProps.layoutSave.payload !== null) {
                        this.props.handleOk()
                    }
                } else {

                }
            } else {

            }
        }

        if(!nextProps.visible){
            this.setState({
                layoutLoading: true,
                menuDetail: {}
            })
        }
    }

    onChangeTab = (key) =>{

    };

    onLayoutChange = (layout,allLayouts) => {
        log.debug(layout);
        log.debug(allLayouts);
        const object = {
            layout: JSON.stringify(layout)
        }
        this.setState({
            currentLayout: object
        });
        this.props.windowResize(document.body.clientHeight,document.body.clientWidth);
    };

    handleOk = () =>{
        const object = this.state.currentLayout;
        if(this.state.menuDetail && this.state.menuDetail.hasOwnProperty("uuid")) {
            this.props.saveLayoutAdmin(this.state.menuDetail.uuid, object);
        }
    };
    handleCancel = () => {
        this.props.handleCancel();
    };

    render() {
        log.debug(this.state.menuDetail);
        const menuDetail  = this.state.menuDetail;

        let layout = this.state.layoutLoadArray;


        let mainComponent;
        if(menuDetail.hasOwnProperty("modules") && menuDetail.modules.length !== 0 ){
            const component = menuDetail.modules.map((value,index) => {
                let module;
                console.log(value.type);
                switch(value.type){
                    //モジュール種別(1: リンクBOX 2: お知らせ 3: アンケート 4: 学年暦 5:ファイル共有 6:休講補講教室変更)
                    case 1:
                        module = (
                            <ModuleLink data={value} parts={value.parts} seeMore={false} title={value.name} />
                        );
                        break;
                    case 2:
                        module = (
                            <ModuleNotification data={value} parts={value.parts} seeMore={true} title={value.name} />
                        );
                        break;
                    case 3:
                        module = (
                            <ModuleQuestionnaire data={value} parts={value.parts}  seeMore={true} title={value.name} />
                        );
                        break;
                    case 4:
                        module = (
                            <ModuleCalendar data={value} parts={value.parts} seeMore={true}  title={value.name} />
                        );
                        break;
                    case 5:
                        module = (
                            <ModuleFileShare data={value} parts={value.parts} seeMore={false} title={value.name}/>
                        );
                        break;
                    case 6:
                        module = (
                            <ModuleCurriculum data={value} parts={value.parts} seeMore={false} title={value.name}/>
                        );
                        break;
                }

                return (
                    <div key={value.uuid}>
                        <div className="drag-handle"></div>
                        {module}
                    </div>
                )
            })



            mainComponent =
                <div className='container clearfix' id="module-wrapper">
                    <ReactGridLayout
                        className="layout"
                        layout={layout}
                        cols={3}
                        onLayoutChange={this.onLayoutChange}
                        isDraggable={true}
                        draggableHandle=".drag-handle"
                        width={this.props.screen.payload.screenWidth * 0.97}>
                        {component}


                    </ReactGridLayout>
                </div>;

        }else{
            mainComponent =
                <div>
                    <NoContent/>
                </div>
            ;
        }


        return (
            <Modal
                className="common-modal layout-settings-modal"
                title={this.state.title}
                visible={this.state.visible}
                maskClosable={false}
                confirmLoading={this.confirmLoading}
                onOk={this.handleOk}
                onCancel={this.handleCancel}>
                {this.state.layoutLoading ?
                    <div style={{padding:"200px 10px",textAlign:"center"}}><LoadingOutlined /> レイアウトを読み込み中...</div>:
                    mainComponent
                }
            </Modal>
        );
    }
}


ModuleLayoutModal.propTypes = {

};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModuleLayoutModal)
